var map = {
	"./button-group/button-group.ts": 8111,
	"./invoice/invoice.ts": 5298,
	"./login/login.ts": 3654,
	"./numpad/numpad.ts": 7264,
	"./order-details/order-details.ts": 1506,
	"./payment/payment.ts": 4569,
	"./user/user.ts": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9837;